import React from "react";
import { FaExclamationCircle, FaExclamationTriangle } from "react-icons/fa";

const ComplianceVerification = () => {
  return (
    <div className="w-full bg-white shadow-md rounded-xl p-6 font-poppins">
      <div className="pr-10">
        <h2 className="font-poppins font-semibold text-20 leading-5 text-black mb-4">
          Compliance Verification
        </h2>
        <p className="font-poppins font-normal text-16 leading-2 text-[#656565] mb-8">
          Oversee regulatory compliance and verify KYC/AML requirements.
        </p>

        <div className="flex justify-between items-center bg-[#FFDCDC] text-black rounded-lg px-4 py-4 mb-5">
          <div className="flex items-center gap-2">
            <FaExclamationCircle className="text-primary-200 text-lg" />
            <p className="text-16 leading-4 font-medium font-poppins ">
              High priority verification needed
            </p>
          </div>
          <span className="text-xs font-poppins font-medium text-12 leading-2 text-primary-200 border border-[#FF0000] bg-white rounded-lg px-3 py-1 ">
            3 Cases
          </span>
        </div>

        <div className="flex justify-between items-center bg-[#FFF8DC] text-black rounded-lg px-4 py-4 mb-8">
          <div className="flex items-center gap-2">
            <FaExclamationTriangle className="text-yellow-600 text-lg" />
            <p className="text-16 leading-4 font-medium font-poppins">
              Medium priority verification
            </p>
          </div>
          <span className="text-xs font-semibold text-[#9C7529] border border-[#9C7529] bg-[#FEF6E6] rounded-lg px-3 py-1">
            8 Cases
          </span>
        </div>

        <button className=" bg-primary-300 text-white w-8/12 py-4 px-4  font-poppins font-medium text-16 leading-4 rounded-md transition">
          Review Compliance Cases
        </button>
      </div>
    </div>
  );
};

export default ComplianceVerification;
